import { render, staticRenderFns } from "./footer-breadcrumbs.vue?vue&type=template&id=6a9e9c84&"
import script from "./footer-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./footer-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./footer-breadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports